<h2 mat-dialog-title>Install SSL Certificate</h2>

<p class="text">
  Installing an SSL certificate will replace any existing certificate for the selected domain.
</p>

<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Type"
      formControlName="type"
      type="select"
      [options]="certificateTypeOptions"
      [hint]="typeHint"
    ></app-input-field>

    <app-input-field
      label="Domain"
      placeholder="Search and select domain"
      formControlName="websiteId"
      type="autocomplete"
      [options]="(websiteOptions$ | async) ?? []"
      [(searchText)]="domainSearchText"
      [errorMessages]="{
        required: 'Domain is required',
      }"
    ></app-input-field>

    <mat-checkbox formControlName="vhostAliases">
      Install SSL for all aliases associated with this website
    </mat-checkbox>

    <app-input-field
      label="Aliases"
      formControlName="altNames"
      type="chips-autocomplete"
      [options]="aliasOptions()"
    ></app-input-field>

    <mat-checkbox formControlName="autoRenew"> Auto Renew - every 2.5 months </mat-checkbox>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button matButton="filled" [disabled]="form.invalid" (click)="submit()">
    Install SSL Certificate
  </button>

  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
